<template>
  <CustomAlert title="" :class="savedStyle">
    <p :class="textStyle">{{ message }}</p>
  </CustomAlert>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";
export default {
  components: {
    CustomAlert
  },
  props: { message: String, savedStyle: String, textStyle: String }
};
</script>
